import React from 'react';
// @ts-ignore
import variables from 'styles/_variables.scss';
import { IIconProps } from '../IIconProps';

export const SignOutIcon = ({
	iconClass = '',
	title = '',
	onClick,
	pointer,
}: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 24 24"
			className={`${iconClass} ${pointer ? 'icon--pointer' : ''}`}
			fill="none"
			onClick={onClick}
		>
			{title && <title>{title}</title>}
			<path
				d="M10 20H5.71429C4.76751 20 4 19.2837 4 18.4V5.6C4 4.71634 4.76751
				 4 5.71429 4H10"
				stroke="currentColor"
			/>
			<path d="M17 16L20 12L17 8" stroke="currentColor" />
			<path d="M20 12H9" stroke="currentColor" />
		</svg>
	);
};
